import React from 'react';
import Modal from '../ui/Modal';
import LoginForm from './LoginForm';
import { useAuth } from '../../context/AuthContext';

interface AuthModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const AuthModal: React.FC<AuthModalProps> = ({ 
  isOpen, 
  onClose
}) => {
  const { user } = useAuth();

  // Close modal if user is authenticated
  React.useEffect(() => {
    if (user) {
      onClose();
    }
  }, [user, onClose]);

  return (
    <Modal
      isOpen={isOpen && !user}
      onClose={onClose}
      title="Sign In to Naia"
    >
      <LoginForm />
    </Modal>
  );
};

export default AuthModal;
